import { CHANGE_PAGE, DISMISS_ERROR, DISMISS_LOADING_SUCCEEDED, SET_ERROR, IS_LOADING } from '../constants/actionTypes';

export const changePage = route => {

    return {
        type:    CHANGE_PAGE,
        payload: { route }
    };

};

export const dismissError = () => {

    return {
        type: DISMISS_ERROR
    };

};

export const dismissLoadingSucceeded = () => {

    return {
        type: DISMISS_LOADING_SUCCEEDED
    };

};

export const setError = error => {

    return {
        type:    SET_ERROR,
        payload: { error }
    };

};

export const isLoading = loading => {

    return {
        type:    IS_LOADING,
        payload: { loading }
    };

};